import type { ReactNode } from "react";
import { Icon, type IconName } from "./icons.js";

type Accent = "primary" | "brand" | "info" | "warning" | "success" | "neutral";

const ACCENT_COLOR: Record<Accent, string> = {
  primary: "var(--color-primary)",
  brand: "var(--color-brand)",
  info: "var(--color-info)",
  warning: "var(--color-warning)",
  success: "var(--color-success)",
  neutral: "var(--color-text-subtle)",
};

interface KpiTileProps {
  label: ReactNode;
  value: ReactNode;
  unit?: string;
  foot?: ReactNode;
  icon?: IconName;
  accent?: Accent;
}

/** Uniform white KPI tile with a single thin accent bar (no pastel fills). */
export function KpiTile({ label, value, unit, foot, icon, accent = "primary" }: KpiTileProps) {
  return (
    <div className="kpi">
      <span className="kpi__accent" style={{ background: ACCENT_COLOR[accent] }} />
      {icon && <span className="kpi__icon"><Icon name={icon} size={18} /></span>}
      <span className="kpi__label">{label}</span>
      <span className="kpi__value">
        {value}
        {unit && <span className="kpi__unit">{unit}</span>}
      </span>
      {foot && <span className="kpi__foot">{foot}</span>}
    </div>
  );
}
